import { Component, OnInit, Input } from '@angular/core';
import { User } from 'src/app/shared/models/user.model';
import { Helper } from 'src/app/shared/helpers/helper';
import { NavService } from '../../services/nav-menu.service';
import { AuthService } from '../../services/auth.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public userLogged: User = {};
  logo = '';

  constructor(
    private sidenav: NavService,
    private authService: AuthService
  ) {
    this.logo = Helper.getLogo();
  }

  ngOnInit() {
    this.userLogged = this.authService.getUserLogged();
  }

  toggleSidenav() {
    this.sidenav.toggle();
  }

  logout() {
    this.authService.logout();
  }
}
